import { liteClient } from '../node_modules/algoliasearch/dist/lite/builds/browser.js';

var ALGOLIA_APP_ID = 'A31FV0KTHH';
var ALGOLIA_CLIENT = '2616b819315a92abf68c6db6484b5aa9';

// Sandbox for testing
var SANDBOX_APP_ID = 'testingUT60ZKBEX6';
var SANDBOX_CLIENT = 'b08e87b98344955186a90ce67a36e58a';
var algoliaSearchClients = {
  sandbox: liteClient(SANDBOX_APP_ID, SANDBOX_CLIENT),
  prod: liteClient(ALGOLIA_APP_ID, ALGOLIA_CLIENT)
};
var getIndexName = function getIndexName(tenant, environment, locale, suffix) {
  return "".concat(tenant, "_").concat(environment, "_").concat(locale, "_").concat(suffix).toLowerCase();
};
var getIndexNameDiscovery = function getIndexNameDiscovery(tenant, environment, locale) {
  return "".concat(tenant, "_").concat(environment, "_Discovery_").concat(locale);
};

export { ALGOLIA_APP_ID, ALGOLIA_CLIENT, SANDBOX_APP_ID, SANDBOX_CLIENT, algoliaSearchClients, getIndexName, getIndexNameDiscovery };
//# sourceMappingURL=algolia.js.map
